import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './QuestionCard.module.css';

const isOthersOption = (option) => typeof option === 'string' && option.trim().toLowerCase() === 'others';

export default function QuestionCard({ question, answer, onAnswer, otherText, onOtherTextChange }) {
  const isMulti = question.type === 'multi';

  const isSelected = (index) => (isMulti ? Array.isArray(answer) && answer.includes(index) : answer === index);

  const othersIndex = question.options.findIndex(isOthersOption);
  const isOthersSelected = othersIndex !== -1 && isSelected(othersIndex);

  const handleSelect = (index) => {
    if (isMulti) {
      const current = Array.isArray(answer) ? answer : [];
      const next = current.includes(index) ? current.filter((i) => i !== index) : [...current, index];
      onAnswer(next);
    } else {
      onAnswer(index);
    }
  };

  return (
    <motion.div
      className={`${styles.card} aira-card`}
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <h2 className={styles.question}>{question.title}</h2>
      {isMulti && <p className={styles.hint}>Select all that apply</p>}

      <div className={styles.options}>
        {question.options.map((option, index) => {
          const selected = isSelected(index);
          return (
            <button
              key={option}
              type="button"
              className={`${styles.option} ${selected ? styles.optionSelected : ''}`}
              onClick={() => handleSelect(index)}
              aria-pressed={selected}
            >
              <span className={`${styles.marker} ${isMulti ? styles.markerSquare : styles.markerRound}`}>
                {selected && (isMulti ? '✓' : <span className={styles.dot} />)}
              </span>
              {option}
            </button>
          );
        })}
      </div>

      <AnimatePresence initial={false}>
        {isOthersSelected && (
          <motion.div
            key="other-input"
            initial={{ opacity: 0, height: 0, marginTop: 0 }}
            animate={{ opacity: 1, height: 'auto', marginTop: 12 }}
            exit={{ opacity: 0, height: 0, marginTop: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            className={styles.otherWrap}
          >
            <input
              type="text"
              className={styles.otherInput}
              placeholder="Please specify..."
              value={otherText || ''}
              onChange={(e) => onOtherTextChange && onOtherTextChange(e.target.value)}
              autoFocus
            />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
